/**
 * Marketing benchmarks for remodelers / design-build firms.
 * Drives color coding and coaching cues on the Marketing dashboard.
 */

export const MARKETING_BENCHMARKS = {
  closeRatio: {
    label: 'Close Ratio',
    unit: '%',
    good: 30,
    ok: 20,
    higherIsBetter: true,
    target: '25-35% for qualified leads'
  },
  costPerLead: {
    label: 'Cost Per Lead',
    unit: '$',
    good: 75,
    ok: 150,
    higherIsBetter: false,
    target: 'Under $100 per lead'
  },
  marketingRoi: {
    label: 'Marketing ROI',
    unit: '%',
    good: 300,
    ok: 100,
    higherIsBetter: true,
    target: '3x+ return on ad spend'
  },
  openRate: {
    label: 'Email Open Rate',
    unit: '%',
    good: 35,
    ok: 20,
    higherIsBetter: true,
    target: '30%+ open rate'
  },
  reviewRating: {
    label: 'Average Rating',
    unit: 'stars',
    good: 4.5,
    ok: 4.0,
    higherIsBetter: true,
    target: '4.5+ stars on Google'
  },
  websiteEngagement: {
    label: 'Engagement Rate',
    unit: '%',
    good: 55,
    ok: 40,
    higherIsBetter: true,
    target: '50%+ engaged sessions'
  },
  seoScore: {
    label: 'SEO Score',
    unit: '/100',
    good: 80,
    ok: 60,
    higherIsBetter: true,
    target: '80+ SEO score'
  },
  leadsYtd: {
    label: 'Leads YTD',
    unit: '',
    good: 100,
    ok: 50,
    higherIsBetter: true,
    target: 'Hit your annual lead goal'
  }
};

export const getMetricStatus = (metricKey, value) => {
  const b = MARKETING_BENCHMARKS[metricKey];
  if (!b || value == null || Number.isNaN(value)) return 'none';
  if (b.higherIsBetter) {
    if (value >= b.good) return 'good';
    if (value >= b.ok) return 'ok';
    return 'poor';
  }
  if (value <= b.good) return 'good';
  if (value <= b.ok) return 'ok';
  return 'poor';
};

export const getCoachingCue = (metricKey, status) => {
  const b = MARKETING_BENCHMARKS[metricKey];
  if (!b) return '';
  if (status === 'good') return `Healthy. Target: ${b.target}.`;
  if (status === 'ok') return `Close to target. Aim for ${b.target}.`;
  if (status === 'poor') return `Below target. Goal: ${b.target}.`;
  return `Target: ${b.target}.`;
};
